/* unplugin-vue-components disabled */import { render } from "./PositionBizPutResList.vue?vue&type=template&id=d6892d6a&scoped=true"
import script from "./PositionBizPutResList.vue?vue&type=script&lang=js"
export * from "./PositionBizPutResList.vue?vue&type=script&lang=js"

import "./PositionBizPutResList.vue?vue&type=style&index=0&id=d6892d6a&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6892d6a"]])

export default __exports__